import { isRouteErrorResponse, useRouteError } from "react-router";
import type { ProblemDetails } from "../../client";
import { Error } from "./Error";

/**
 * Route-level error boundary: renders failures thrown from route `loader`s
 * (API `ProblemDetails` responses or anything else) through the shared
 * `Error` view.
 */
export function RouteErrorBoundary() {
    const error = useRouteError();

    if (isRouteErrorResponse(error)) {
        let problem: unknown = error.data;
        if (typeof problem === "string") {
            try {
                problem = JSON.parse(problem);
            } catch {
                problem = undefined;
            }
        }
        return <Error error={(problem as ProblemDetails) ?? { title: error.statusText, status: error.status }} />;
    }

    return <Error error={error} />;
}
